var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30 26a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12.063a3 3 0 0 1 2.305 1.08l1.6 1.92H27a3 3 0 0 1 3 3zM28 9.17c-.313-.11-.65-.17-1-.17H8a3 3 0 0 0-3 3v.5c-.35 0-.687.06-1 .17V6a1 1 0 0 1 1-1h12.063a1 1 0 0 1 .768.36l1.9 2.28A1 1 0 0 0 20.5 8H27a1 1 0 0 1 1 1zM14.985 12.5l1.072-1.5H8a1 1 0 0 0-1 1v.5z",
    clipRule: "evenodd",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocuments);
export default __webpack_public_path__ + "static/media/new-documents.4dac7b013f863b656a8044ae10875cc8.svg";
export { ForwardRef as ReactComponent };